/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Add_Issue_LabelInputs */

const en_manual_qc_add_issue_label = /** @type {(inputs: Manual_Qc_Add_Issue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add new issue`)
};

const fr_manual_qc_add_issue_label = /** @type {(inputs: Manual_Qc_Add_Issue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter un incident`)
};

const de_manual_qc_add_issue_label = /** @type {(inputs: Manual_Qc_Add_Issue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neues Problem hinzufügen`)
};

const it_manual_qc_add_issue_label = /** @type {(inputs: Manual_Qc_Add_Issue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi un nuovo problema`)
};

const ru_manual_qc_add_issue_label = /** @type {(inputs: Manual_Qc_Add_Issue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавить новый выпуск`)
};

const es_manual_qc_add_issue_label = /** @type {(inputs: Manual_Qc_Add_Issue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir nuevo problema`)
};

const zh_cn2_manual_qc_add_issue_label = /** @type {(inputs: Manual_Qc_Add_Issue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加新问题`)
};

const ja_manual_qc_add_issue_label = /** @type {(inputs: Manual_Qc_Add_Issue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい問題を追加`)
};

const hi_manual_qc_add_issue_label = /** @type {(inputs: Manual_Qc_Add_Issue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया मुद्दा जोड़ें`)
};

const pt_pt2_manual_qc_add_issue_label = /** @type {(inputs: Manual_Qc_Add_Issue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar novo problema`)
};

/**
* | output |
* | --- |
* | "Add new issue" |
*
* @param {Manual_Qc_Add_Issue_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_add_issue_label = /** @type {((inputs?: Manual_Qc_Add_Issue_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Add_Issue_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_add_issue_label(inputs)
	if (locale === "de") return de_manual_qc_add_issue_label(inputs)
	if (locale === "it") return it_manual_qc_add_issue_label(inputs)
	if (locale === "ru") return ru_manual_qc_add_issue_label(inputs)
	if (locale === "es") return es_manual_qc_add_issue_label(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_add_issue_label(inputs)
	if (locale === "ja") return ja_manual_qc_add_issue_label(inputs)
	if (locale === "hi") return hi_manual_qc_add_issue_label(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_add_issue_label(inputs)
	return en_manual_qc_add_issue_label(inputs)
});